import util from '@bmp-vue/core/api/util'
const controller = 'Multiplo'
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  PostAdmin: function (acao, dto, codigoIntegracaoBMP) {
    var request = { acao: acao, Dto: dto, codigoIntegracaoBMP: codigoIntegracaoBMP }
    var header = { headers: { acao: acao } }

    return util.Axios.Post(controller, request, header)
  },
  AuthCheck: function (acao, dto, codigoIntegracaoBMP) {
    var request = { acao: acao, Dto: dto, codigoIntegracaoBMP: codigoIntegracaoBMP }
    var header = { headers: { acao: acao } }

    return util.Axios.Post(controller, request, header)
  },
})
